import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import ITTrainingHeader from '../components/ITTrainingHeader';
import ITTrainingFooter from '../components/ITTrainingFooter';

const slides = [
  { src: '/ITTrainingJob1.png',    alt: 'IT Training at Vedanskrix',  caption: 'Launch Your IT Career With Expert Training' },
  { src: '/ITTrainingJob2.png',    alt: 'Programming Courses',         caption: 'Learn Python, Java, PHP, Android & More' },
  { src: '/ITTrainingjob3.png',    alt: 'Career & Job Placement',      caption: 'Career Support & Job Placement Assistance' },
  { src: '/it-training-banner.png',alt: 'IT Training Centre',          caption: 'Industry-Focused Training in Ahmedabad' },
  { src: '/Trainingimg.png',       alt: 'Hands-On Training',           caption: 'Hands-On Learning With Real Projects' },
];

// Each tech logo links to its dedicated course detail page
const techLogos = [
  { name: 'Python',      color: '#3776AB', bg: '#EEF5FB', letter: 'Py',  slug: 'python-training' },
  { name: 'PHP',         color: '#777BB4', bg: '#F3F2FB', letter: 'PHP', slug: 'php-mysql-training' },
  { name: 'Java',        color: '#ED8B00', bg: '#FFF5E6', letter: 'Ja',  slug: 'java-training' },
  { name: 'Android',     color: '#3DDC84', bg: '#EDFBF3', letter: '🤖',  slug: 'android-training' },
  { name: 'iOS',         color: '#555555', bg: '#F5F5F5', letter: '',    slug: 'iphone-training' },
  { name: 'HTML5',       color: '#E34F26', bg: '#FEF0EC', letter: 'H5',  slug: 'web-design-training' },
  { name: 'CSS3',        color: '#1572B6', bg: '#EEF5FB', letter: 'CSS', slug: 'web-design-training' },
  { name: 'JavaScript',  color: '#F7DF1E', bg: '#FFFDE7', letter: 'JS',  slug: 'web-design-training', dark: true },
  { name: 'WordPress',   color: '#21759B', bg: '#EEF5FA', letter: 'WP',  slug: 'wordpress-training' },
  { name: 'MySQL',       color: '#4479A1', bg: '#EEF5FB', letter: 'My',  slug: 'php-mysql-training' },
  { name: 'Odoo',        color: '#714B67', bg: '#F5EFF4', letter: 'Od',  slug: 'odoo-training' },
  { name: 'Drupal',      color: '#0678BE', bg: '#EEF5FB', letter: 'Dr',  slug: 'drupal-training' },
  { name: 'SEO',         color: '#F4511E', bg: '#FEF0EC', letter: 'SEO', slug: 'seo-training' },
  { name: 'IoT',         color: '#00B4D8', bg: '#E8F9FC', letter: 'IoT', slug: 'iot-training' },
  { name: 'Big Data',    color: '#FF6B35', bg: '#FFF0EA', letter: 'BD',  slug: 'big-data-training' },
  { name: 'Machine Learning', color: '#9B59B6', bg: '#F5EEF8', letter: 'ML', slug: 'machine-learning' },
  { name: 'C / C++',     color: '#00599C', bg: '#EEF5FB', letter: 'C++', slug: 'cpp-language-training' },
  { name: 'Testing',     color: '#27AE60', bg: '#EDFBE8', letter: 'QA',  slug: 'software-testing' },
];

// Course cards on the main page — each linked to its detail page
const courses = [
  { icon: '🐍', title: 'Python Training',     tag: 'Most Popular', slug: 'python-training',          desc: 'Core Python, Django, Flask, data science libraries and real-world projects.' },
  { icon: '📱', title: 'Android & iOS',        tag: 'High Demand',  slug: 'android-training',         desc: 'Build Android apps with Kotlin and iOS apps with Swift from scratch.' },
  { icon: '🌐', title: 'PHP / MySQL',          tag: 'Web Backend',  slug: 'php-mysql-training',       desc: 'Server-side development with PHP, MySQL, CodeIgniter, WordPress & more.' },
  { icon: '☕', title: 'Java Training',        tag: 'Enterprise',   slug: 'java-training',            desc: 'Core Java, OOP concepts, Spring framework, and enterprise application development.' },
  { icon: '🤖', title: 'Machine Learning',     tag: 'AI/ML',        slug: 'machine-learning',         desc: 'Python ML libraries, data preprocessing, model training and AI project building.' },
  { icon: '🎨', title: 'Web Design',           tag: 'Creative',     slug: 'web-design-training',      desc: 'HTML5, CSS3, JavaScript, Photoshop and responsive UI design for modern websites.' },
  { icon: '📊', title: 'Digital Marketing',    tag: 'Growth',       slug: 'digital-marketing-nonprog',desc: 'SEO, Google Ads, social media marketing, content strategy and analytics.' },
  { icon: '📡', title: 'IoT Training',         tag: 'Hardware+SW',  slug: 'iot-training',             desc: 'Arduino, Raspberry Pi, sensor integration and connected device programming.' },
  { icon: '🧪', title: 'Software Testing',     tag: 'QA',           slug: 'software-testing',         desc: 'Manual testing, Selenium automation, JIRA, TestNG and QA best practices.' },
];

const whyUs = [
  { icon: '🎓', title: 'Expert Trainers',   desc: 'Industry professionals with 5+ years of real-world experience.' },
  { icon: '🛠️', title: 'Live Projects',     desc: 'Work on real projects you can add to your portfolio.' },
  { icon: '📄', title: 'Job Placement',     desc: 'Resume help, mock interviews and direct job referrals.' },
  { icon: '🕐', title: 'Flexible Batches',  desc: 'Morning, evening and weekend batches available.' },
  { icon: '📜', title: 'Certificate',       desc: 'Industry-recognized certificate on successful completion.' },
  { icon: '💬', title: 'Mentorship',        desc: 'One-on-one doubt sessions and personal career guidance.' },
];

function ITTraining() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(c => (c + 1) % slides.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="itp">
      <Seo
        title="IT Training & Job Placement Ahmedabad | Vedanskrix"
        description="Join Vedanskrix IT Training in Ahmedabad. Expert-led courses in Python, Java, PHP, Android, Web Design, Digital Marketing & more — with job placement assistance."
        keywords={['IT training Ahmedabad','Python course','PHP training','Android training','web design course','job placement Ahmedabad','Java training','digital marketing course','machine learning training','IoT training','best IT institute Gujarat','software testing course','IT training centre Vastral']}
        schema={{
          '@context': 'https://schema.org',
          '@type': 'EducationalOrganization',
          name: 'Vedanskrix IT Training & Job Placement',
          description: 'Professional IT training institute in Ahmedabad offering Python, Java, PHP, Android, Web Design, and Digital Marketing courses with placement assistance.',
          url: 'https://vedanskrix.com/it-training',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'E-106 Akshardham Heights, S.P. Ring Road, Vastral Road',
            addressLocality: 'Ahmedabad',
            addressRegion: 'Gujarat',
            postalCode: '382418',
            addressCountry: 'IN'
          }
        }}
      />

      <ITTrainingHeader />

      {/* ── Slider ── */}
      <section className="itp-slider" aria-label="Featured slides">
        <div className="itp-slider__track">
          {slides.map((s, i) => (
            <div key={i} className={i === current ? 'itp-slide active' : 'itp-slide'} aria-hidden={i !== current}>
              <img src={s.src} alt={s.alt} className="itp-slide__img" />
              <div className="itp-slide__overlay" />
              <div className="itp-slide__caption">
                <span className="itp-slide__eyebrow">Vedanskrix IT Training</span>
                <h2 className="itp-slide__title">{s.caption}</h2>
                <div className="itp-slide__actions">
                  <Link to="/contact" className="itp-slide__btn itp-slide__btn--primary">Enroll Now</Link>
                  <Link to="/programming" className="itp-slide__btn itp-slide__btn--outline">View Courses</Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="itp-slider__dots" role="tablist">
          {slides.map((_, i) => (
            <button
              key={i}
              className={i === current ? 'itp-slider__dot active' : 'itp-slider__dot'}
              onClick={() => setCurrent(i)}
              aria-label={`Slide ${i + 1}`}
              role="tab"
              aria-selected={i === current}
            />
          ))}
        </div>
        <button className="itp-slider__arr itp-slider__arr--prev" onClick={() => setCurrent(c => (c - 1 + slides.length) % slides.length)} aria-label="Previous slide">‹</button>
        <button className="itp-slider__arr itp-slider__arr--next" onClick={() => setCurrent(c => (c + 1) % slides.length)} aria-label="Next slide">›</button>
      </section>

      {/* ── Company Description ── */}
      <section className="itp-about">
        <div className="itp-container itp-about__inner">
          <div className="itp-about__text">
            <span className="itp-eyebrow">About Vedanskrix</span>
            <h2>Ahmedabad's Trusted IT Training Centre</h2>
            <p>
              Vedanskrix Web LLP is an Ahmedabad-based technology and training company helping students and professionals build strong, job-ready IT skills. We offer hands-on, industry-focused courses in programming, web design, digital marketing, IoT, and more.
            </p>
            <p>
              Our experienced trainers guide each student through real projects, practical assignments, and interview preparation — ensuring you are fully ready for the job market by the time you complete your training. With flexible batch timings and dedicated placement support, Vedanskrix is the right place to start or accelerate your IT career.
            </p>
            <div className="itp-about__stats">
              <div className="itp-astat"><strong>500+</strong><span>Students Trained</span></div>
              <div className="itp-astat"><strong>32+</strong><span>Courses</span></div>
              <div className="itp-astat"><strong>95%</strong><span>Placement Rate</span></div>
              <div className="itp-astat"><strong>5+</strong><span>Years Experience</span></div>
            </div>
            <Link to="/contact" className="itp-btn itp-btn--red">Get Free Counselling</Link>
          </div>
          <div className="itp-about__img-wrap">
            <img src="/aboutus.png" alt="About Vedanskrix" className="itp-about__img" />
          </div>
        </div>
      </section>

      {/* ── Technology Logos — each links to course detail page ── */}
      <section className="itp-tech">
        <div className="itp-container">
          <div className="itp-section-head">
            <span className="itp-eyebrow">Technologies We Teach</span>
            <h2>Our Training Technologies</h2>
            <p>Master the tools and languages that today's employers demand.</p>
          </div>
          <div className="itp-tech-grid">
            {techLogos.map((t) => (
              <Link
                key={t.name}
                to={`/course/${t.slug}`}
                className="itp-tech-card"
                style={{'--tc': t.color, '--tbg': t.bg}}
                title={`${t.name} Training`}
              >
                <div className="itp-tech-icon" style={{background: t.bg, color: t.color}}>
                  <span>{t.letter}</span>
                </div>
                <span className="itp-tech-name">{t.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ── Courses — each links to course detail page ── */}
      <section className="itp-section itp-section--grey">
        <div className="itp-container">
          <div className="itp-section-head">
            <span className="itp-eyebrow">What We Offer</span>
            <h2>Our Training Courses</h2>
            <p>Industry-relevant programs designed to get you job-ready fast.</p>
          </div>
          <div className="itp-courses-grid">
            {courses.map((c) => (
              <div key={c.slug} className="itp-course-card">
                <div className="itp-course-top">
                  <span className="itp-course-icon">{c.icon}</span>
                  <span className="itp-course-tag">{c.tag}</span>
                </div>
                <h3>{c.title}</h3>
                <p>{c.desc}</p>
                <div style={{display:'flex', gap:'8px', flexWrap:'wrap', marginTop:'auto'}}>
                  <Link to={`/course/${c.slug}`} className="itp-course-cta">View Course →</Link>
                  <Link to="/contact" className="itp-course-cta itp-course-cta--outline">Enquire</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Why Choose Us ── */}
      <section className="itp-section itp-section--dark">
        <div className="itp-container">
          <div className="itp-section-head itp-section-head--light">
            <span className="itp-eyebrow itp-eyebrow--gold">Why Vedanskrix</span>
            <h2>Why Choose Our Training?</h2>
          </div>
          <div className="itp-why-grid">
            {whyUs.map((w, i) => (
              <div key={i} className="itp-why-card">
                <div className="itp-why-icon">{w.icon}</div>
                <h3>{w.title}</h3>
                <p>{w.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA Banner ── */}
      <section className="itp-cta-banner">
        <div className="itp-container itp-cta-banner__inner">
          <div>
            <h2 className="itp-cta-banner__title">Ready to Start Your IT Career?</h2>
            <p className="itp-cta-banner__sub">Join Vedanskrix today — expert trainers, live projects, and placement support.</p>
          </div>
          <div style={{display:'flex', gap:'12px', flexWrap:'wrap'}}>
            <Link to="/contact" className="itp-btn itp-btn--red">Enroll Now</Link>
            <Link to="/programming" className="itp-btn itp-btn--outline">Browse Courses</Link>
          </div>
        </div>
      </section>

      <ITTrainingFooter />
    </div>
  );
}

export default ITTraining;
